import { useContext } from "react";
import {
  PlayerDataContext,
  PlayerDataContextType as PlayerDataContextType,
} from "../providers/PlayerDataContext";

export const usePlayerData = (): PlayerDataContextType => {
  const context = useContext(PlayerDataContext);
  if (!context) {
    throw new Error("usePlayerData must be used within a PlayerDataProvider");
  }
  return context;
};
